"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Price = require("./Price");
Object.keys(_Price).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Price[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Price[key];
    }
  });
});